/**
 * R174: Material bag — client-side container для добытых руд/трав/кожи.
 * localStorage 'aiwari-mat-bag'. Server-sync — TODO Phase 2.
 *
 * Используется ResourceNode click-handler + Crafting UI (TODO).
 */

import { create } from 'zustand';

const STORAGE_KEY = 'aiwari-mat-bag';

function load(): Record<string, number> {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch { return {}; }
}
function save(bag: Record<string, number>): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(bag));
  window.dispatchEvent(new CustomEvent('aiwari-mat-bag-changed', { detail: { bag } }));
}

interface MatBagState {
  bag: Record<string, number>;
  add: (id: string, qty: number) => void;
  consume: (id: string, qty: number) => boolean;
  count: (id: string) => number;
}

export const useMatBag = create<MatBagState>((set, get) => ({
  bag: load(),
  add: (id, qty) => {
    const next = { ...get().bag, [id]: (get().bag[id] ?? 0) + qty };
    set({ bag: next });
    save(next);
  },
  consume: (id, qty) => {
    const have = get().bag[id] ?? 0;
    if (have < qty) return false;
    const next = { ...get().bag, [id]: have - qty };
    if (next[id] === 0) delete next[id];
    set({ bag: next });
    save(next);
    return true;
  },
  count: (id) => get().bag[id] ?? 0,
}));
